export default "__VITE_ASSET__BrO9vREJ__"